module.exports = __webpack_public_path__ + "static/media/pinch.4a5b4d57.png";